import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Points from './Points'

function ExploreOurMembershipsSection() {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Column
          alignCenter
          gap={11}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          px={LANDING_CONTENT_PX}
          py={80}
        >
          <SubsectionTitle
            centered
            subtitle="It’s networking done the smart way."
            title="Explore Our Memberships for Corporate & Individual"
          />

          <Points />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default ExploreOurMembershipsSection
